import {
  buildResultItem,
  fetchSearchResults,
  getPagefind,
  preloadSearch,
} from './search-core.js';

const input = document.getElementById('site-search');
const resultsEl = document.getElementById('search-results');
const statusEl = document.getElementById('search-status');

if (!input || !resultsEl || !statusEl) {
  throw new Error('Search page markup is missing required elements');
}

function renderResults(items) {
  resultsEl.replaceChildren();
  const frag = document.createDocumentFragment();
  for (const item of items) {
    frag.append(buildResultItem(item));
  }
  resultsEl.append(frag);
}

function setStatus(total, q) {
  if (!q.trim()) {
    statusEl.textContent = '';
    return;
  }
  if (total === 0) {
    statusEl.textContent = `No results for “${q}”`;
  } else if (total === 1) {
    statusEl.textContent = '1 result';
  } else {
    statusEl.textContent = `${total} results`;
  }
}

async function runSearch(term) {
  const q = term.trim();
  if (!q) {
    resultsEl.replaceChildren();
    statusEl.textContent = '';
    return;
  }

  statusEl.textContent = 'Searching…';
  const result = await fetchSearchResults(q, {
    limit: 25,
    onError: (msg) => {
      statusEl.textContent = msg;
    },
  });
  if (result === null) return;

  renderResults(result.data);
  setStatus(result.total, q);
}

input.addEventListener('input', (e) => {
  const { value } = e.target;
  preloadSearch(value);
  runSearch(value);
});

input.addEventListener('focus', () => {
  getPagefind((msg) => {
    statusEl.textContent = msg;
  });
});

const params = new URLSearchParams(window.location.search);
const initialQ = params.get('q') ?? '';
if (initialQ) {
  input.value = initialQ;
  runSearch(initialQ);
} else {
  input.focus();
}
